module.exports = __webpack_public_path__ + "static/media/screenshot3.6635a567.png";